module.exports = __webpack_public_path__ + "static/media/improbableModal.bd93aaf9.jpg";